// Re-export from shared to avoid breaking existing imports
export { useShouldShowTopNavbar } from '@24i/nxg-sdk-smartott-shared/src/hooks/useShouldShowTopNavbar';
